const VerifyProcess = () => {
  return (
    <div>
      <div className="modal-header-dark"></div>
      <div className="modal-body-dark white">
        <div>
          <p className="subject-2 marginBottom3 grey-3 yekan">
            در حال بررسی پرداخت و فعال کردن اشتراک
          </p>
        </div>
      </div>
      <div className="modal-footer">
      </div>
    </div>
  );
};

export default VerifyProcess;
